<template>
  <SurveyTab
    v-if="project"
    :project="project"
    :survey="survey"
    @showOverviewTab="$router.push(`/project/${projectId}`)"
    @refreshSurveyTabAfterCreate="refreshSurveyTabAfterCreate"
  />
</template>

<script>
import { mapGetters } from "vuex";

import SurveyTab from "@/components/project/SurveyTab.vue";

export default {
  components: {
    SurveyTab
  },
  props: {
    projectSummary: { type: Object, required: true }
  },
  data() {
    return {
      project: null,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getDataLoading',
      hasLoaded: 'getDataLoaded',
    }),
    projectId() {
      return this.project.projectId;
    },
    survey() {
      return this.projectSummary.project.survey;
    }
  },
  watch: {
  },
  mounted() {
    this.setupPageData();
  },
  methods: {
    setupPageData() {
      this.project = this.projectSummary.project;
    },
    refreshSurveyTabAfterCreate(questions) {
      this.project.survey.questions = questions;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
